export { default as SalesDashboard } from './sales/sales-dashboard.jsx';
export { default as MarketingDashboard } from './marketing/marketing-dashboard.jsx';
